<template>
    <v-dialog v-model="dialog" max-width="1200">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Transaction Details</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-tabs slider-color="grey" v-model="activeTab">
                <v-tab ripple>Transaction</v-tab>
                <v-tab v-if="(data.paymentType == 'DB' || data.paymentType == 'PA' || data.paymentType == 'SD' || data.paymentType == 'CP') && tranInfo.status >= 1" ripple>Actions</v-tab>
                <v-tab ripple>History</v-tab>
                <v-tab ripple>Payload</v-tab>

                <!-- Transaction -->
                <v-tab-item>
                    <v-container fluid grid-list-md class="transaction-tab">
                    <v-data-iterator :items="tableData" content-tag="v-layout" row wrap hide-actions>
                        <template v-slot:item="props">
                            
                            <v-flex xs6>
                            <v-hover>
                                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`">
                                    <v-list dense>
                                        <v-card-title class="primary white--text"><b>Transaction Information</b></v-card-title>
                                        <v-divider></v-divider>
                                        <v-list-tile v-if="props.item.amount">
                                            <v-list-tile-content class="font-weight-bold">Amount:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.amount }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.paymentType != 'SD' && props.item.paymentType != 'DS' && props.item.paymentType != 'RS'">
                                            <v-list-tile-content class="font-weight-bold">Card Expiry:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardExpDate }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.paymentType != 'SD' && props.item.paymentType != 'DS' && props.item.paymentType != 'RS'">
                                            <v-list-tile-content class="font-weight-bold">Card Holder:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardHolder }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.paymentType != 'SD' && props.item.paymentType != 'DS' && props.item.paymentType != 'RS'">
                                            <v-list-tile-content class="font-weight-bold">Card Number:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardNumber }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.currency">
                                            <v-list-tile-content class="font-weight-bold">Currency:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.currency }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Date:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.processingTime }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.merchantTransactionId">
                                            <v-list-tile-content class="font-weight-bold">Merchant Transaction ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.merchantTransactionId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.paymentBrand">
                                            <v-list-tile-content class="font-weight-bold">Payment Brand:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.paymentBrand }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Payment Type:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.paymentType }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.recurringType">
                                            <v-list-tile-content class="font-weight-bold">Recurring Type:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.recurringType }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Status Description:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.resultDesc }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Status Code:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.resultCode }}</v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-hover>
                            </v-flex>
                            
                            <v-flex xs6>
                            <v-hover>
                                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`">
                                    <v-list dense>
                                        <v-card-title class="primary white--text"><b>Gateway Information</b></v-card-title>
                                        <v-divider></v-divider>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Channel ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.channelId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Channel Name:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.channelName }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.clearingInstitute">
                                            <v-list-tile-content class="font-weight-bold">Clearing Institute:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.clearingInstitute }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">DB ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.dbId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Merchant ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.merchantId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Merchant Name:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.merchantName }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">UUID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.uuid }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.paymentType == 'RF'">
                                            <v-list-tile-content class="font-weight-bold">Reference ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.referenceId }}</v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-hover>
                            </v-flex>
                        </template>
                    </v-data-iterator>
                    </v-container>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>
                
                <!-- Action -->
                <v-tab-item v-if="(data.paymentType == 'DB' || data.paymentType == 'PA' || data.paymentType == 'SD' || data.paymentType == 'DS' || data.paymentType == 'CP') && tranInfo.status >= 1">
                    <v-flex v-if="data.paymentType != 'SD'" xs3 class="pr-5">
                        <v-card-text class="text-sm-left">
                        <div>
                            <v-text-field class="refund-amount" type="number" v-model="data.refundAmount" label="Amount"></v-text-field>
                        </div>
                        </v-card-text>
                    </v-flex>
                    <v-layout v-else class="pl-3 pr-3" xs12 justify-center align-center>
                        <v-timeline class="xs8 flex">
                            <v-timeline-item color="primary" small left>
                            <v-card>
                                <v-card-title class="primary pa-2">
                                <v-icon dark size="20" class="mr-3">
                                    mdi-calendar-multiple-check
                                </v-icon>
                                <b class="white--text">{{ scheduleDates[0]['name'] }}</b>
                                </v-card-title>
                                <v-container class="pa-2" text-xs-left grid-list-md>
                                    <v-layout align-center>
                                        <v-flex xs12>
                                            {{ scheduleDates[0]['date'] }}
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card>
                            </v-timeline-item>

                            <v-timeline-item color="blue lighten-2" small right>
                            <v-card>
                                <v-card-title class="blue lighten-2 pa-2">
                                <v-icon v-if="scheduleDates[1]['name'] == 'Unexecuted'" dark size="20" class="mr-3">
                                    mdi-calendar-remove
                                </v-icon>
                                <v-icon v-else dark size="20" class="mr-3">
                                    mdi-calendar-clock
                                </v-icon>
                                <b class="white--text">{{ scheduleDates[1]['name'] }}</b>
                                </v-card-title>
                                <v-container class="pa-2" text-xs-left grid-list-md>
                                    <v-layout align-center>
                                        <v-flex xs12>
                                            {{ scheduleDates[1]['date'] }}
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card>
                            </v-timeline-item>

                            <v-timeline-item :color="scheduleDates[2]['name'] == 'End Date' ? 'red' : 'blue lighten-2'" small left>
                            <v-card>
                                <v-card-title class="pa-2" :class="scheduleDates[2]['name'] == 'End Date' ? 'red' : 'blue lighten-2'">
                                <v-icon v-if="scheduleDates[2]['name'] == 'End Date'" dark size="20" class="mr-3">
                                    mdi-close
                                </v-icon>
                                <v-icon v-else dark size="20" class="mr-3">
                                    mdi-calendar-clock
                                </v-icon>
                                <b class="white--text">{{ scheduleDates[2]['name'] }}</b>
                                </v-card-title>
                                <v-container class="pa-2" text-xs-left grid-list-md>
                                    <v-layout align-center>
                                        <v-flex xs12>
                                            {{ scheduleDates[2]['date'] }}
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card>
                            </v-timeline-item>
                        </v-timeline>
                        </v-layout>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="(data.paymentType == 'DB')" color="error" @click="refund()">Refund</v-btn>
                        <v-btn v-if="(data.paymentType == 'DB' || data.paymentType == 'CP')" color="error" @click="reversal()">Reversal</v-btn>
                        <v-btn v-if="(data.paymentType == 'PA')" color="primary" @click="capture()">Capture</v-btn>
                        <v-btn v-if="(data.paymentType == 'SD')" color="error" @click="deschedule()">Deschedule</v-btn>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>

                <!-- History -->
                <v-tab-item>
                    <v-card-text class="text-sm-left">
                        <v-data-table :headers="tableHeaders" :items="data.references" class="elevation-1 transaction-history-table" hide-actions>
                            <template slot="items" slot-scope="props">
                                <td v-if="props.item.status == 1" class="justify-center layout px-0 refund-container">
                                    <v-icon small class="mr-2 vertical-align-middle" color="green">
                                        done
                                    </v-icon>
                                </td>
                                <td v-else-if="props.item.status == 0" class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="red">
                                        clear
                                    </v-icon>
                                </td>
                                <td v-else class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="blue">
                                        history
                                    </v-icon>
                                </td>
                                <td :class="{ highlightRow: props.item.uuid ==  tranInfo.uuid }" class="text-xs-left">{{ props.item.processingTime }}</td>
                                <td :class="{ highlightRow: props.item.uuid ==  tranInfo.uuid }" class="text-xs-left">{{ props.item.paymentType }}</td>
                                <td :class="{ highlightRow: props.item.uuid ==  tranInfo.uuid }" class="text-xs-left">{{ props.item.amount }}</td>
                                <td :class="{ highlightRow: props.item.uuid ==  tranInfo.uuid }" class="text-xs-left">{{ props.item.currency }}</td>
                                <td v-if="props.item.paymentType == 'SD'" :class="{ highlightRow: props.item.uuid ==  tranInfo.uuid }" class="text-xs-left">{{ JSON.parse(props.item.json).payload.card.result.description }}</td>
                                <td v-else :class="{ highlightRow: props.item.uuid ==  tranInfo.uuid }" class="text-xs-left">{{ JSON.parse(props.item.json).payload.result.description }}</td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>
            
                <!-- Payload -->
                <v-tab-item>
                    <v-card-text class="text-sm-left">
                        <pre>{{ json }}</pre>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-dialog>
</template>

<script>
    import sweetAlert from '../sweetAlert.js';
    import axios from 'axios';

    export default {
        data() {
            return {
                data: {},
                tableData: [],
                activeTab: 0,
                tableHeaders: [{ text: 'Status', value: 'status', sortable: false, align: 'center' },
                               { text: 'Date', value: 'date', sortable: false, align: 'left' },
                               { text: 'Payment Type', value: 'paymentType', sortable: false, align: 'left' },
                               { text: 'Amount', value: 'amount', sortable: false, align: 'left' },
                               { text: 'Currency', value: 'currency', sortable: false, align: 'left' },
                               { text: 'Status', value: 'status', sortable: false, align: 'left' }],
                json: null,
                currentDatetime: (new Date()).toISOString().slice(0, 19).replace("T", " "),
                delay: 4000
            }
        },
        mixins: [ sweetAlert ],
        props: {
            visible: Boolean,
            tranInfo: Object,
            references: Array,
            scheduleDates: Array
        },
        computed: {
            dialog: {
                get() {
                    if(this.visible) {
                        this.json = JSON.parse(this.tranInfo.json);
                        this.data.amount = this.tranInfo.amount;
                        let expMonth = null;
                        if('expiryMonth' in this.tranInfo && this.tranInfo.expiryMonth.toString().length == 1) { expMonth = `0${this.tranInfo.expiryMonth}` } else { expMonth = `${this.tranInfo.expiryMonth}` };
                        this.data.cardExpDate = 'expiryMonth' in this.tranInfo ? `${expMonth} / ${this.tranInfo.expiryYear}` : null;
                        this.data.cardHolder = this.tranInfo.holder;
                        this.data.cardNumber = 'bin' in this.tranInfo ? `${this.tranInfo.bin}******${this.tranInfo.last4Digits}` : null;
                        this.data.channelId = this.tranInfo.channelUuid;
                        this.data.channelName = this.tranInfo.channelName;
                        this.data.clearingInstitute = this.tranInfo.clearingInstitute;
                        this.data.code = this.tranInfo.resultCode;
                        this.data.currency = this.tranInfo.currency;
                        this.data.processingTime = this.tranInfo.processingTime;
                        this.data.dbId = this.tranInfo.id;
                        this.data.merchantId = this.tranInfo.merchantUuid;
                        this.data.merchantName = this.tranInfo.merchantName;
                        this.data.merchantTransactionId = this.tranInfo.merchantTransactionId;
                        this.data.paymentBrand = this.tranInfo.paymentBrand;
                        this.data.paymentType = this.tranInfo.paymentType;
                        this.data.references = this.references;
                        this.data.referenceId = (JSON.parse(this.tranInfo.json).payload || {}).referencedId || null;
                        this.data.recurringType = this.tranInfo.recurringType;
                        this.data.refundAmount = this.tranInfo.amount;
                        this.data.resultCode = this.tranInfo.resultCode;
                        this.data.resultDesc = (JSON.parse(this.tranInfo.json).payload.result || {}).description || this.json.payload.card.result.description;
                        this.data.uuid = this.tranInfo.uuid; 
                        this.tableData[0] = this.data;
                    }
                    return this.visible;
                },
                set(value) {
                    if(!value) {
                        this.activeTab = 0;
                        this.$emit('closeDialog');
                    }
                }
            }
        },
        methods: {
            refund() {
                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/refund',
                    data: { transaction: this.tranInfo, refundAmount: this.data.refundAmount, userId: localStorage.user_id },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.sweetAlert(response.data);
                        setTimeout(() => {
                            this.$emit('getTransactions');
                        }, this.delay);
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            },
            reversal() {
                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/reversal',
                    data: { transaction: this.tranInfo, userId: localStorage.user_id },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.sweetAlert(response.data);
                        setTimeout(() => {
                            this.$emit('getTransactions');
                        }, this.delay);
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            },
            capture() {
                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/capture',
                    data: { transaction: this.tranInfo, userId: localStorage.user_id },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.sweetAlert(response.data);
                        setTimeout(() => {
                            this.$emit('getTransactions');
                        }, this.delay);
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            },
            deschedule() {
                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/deschedule',
                    data: { transaction: this.tranInfo, userId: localStorage.user_id },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.sweetAlert(response.data);
                        setTimeout(() => {
                            this.$emit('getTransactions');
                        }, this.delay);
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            }
        }
    }
</script>